var _g, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeVisible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.027,48.846C80.467,48.05,67.074,29.358,50,29.358S19.533,48.05,18.973,48.846c-0.488,0.691-0.488,1.615,0,2.307    C19.533,51.949,32.926,70.642,50,70.642s30.467-18.693,31.027-19.489C81.516,50.461,81.516,49.538,81.027,48.846z M50,66.642    c-12.727,0-23.76-12.696-26.881-16.643C26.24,46.054,37.273,33.358,50,33.358S73.76,46.054,76.881,50    C73.76,53.946,62.727,66.642,50,66.642z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.002,38C43.385,38,38,43.383,38,50c0,6.617,5.385,12,12.002,12C56.617,62,62,56.617,62,50    C62,43.383,56.617,38,50.002,38z M50.002,58C45.59,58,42,54.411,42,50c0-4.411,3.59-8,8.002-8C54.412,42,58,45.588,58,50    C58,54.411,54.412,58,50.002,58z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 115,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 120,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeVisible);
export default __webpack_public_path__ + "static/media/eye-visible.556e365a425370bbfd19ca168158a811.svg";
export { ForwardRef as ReactComponent };